export { ErrorBoundary } from "./ErrorBoundary";
export { LegacyBoundary } from "./LegacyBoundary";
//# sourceMappingURL=index.js.map